import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React from 'react';
import { Modal, Button } from 'semantic-ui-react';
import Markdown from 'markdown-to-jsx';
import Image from '../../../atoms/Image';
import CloseIconDark from '../assets/CloseIconDark.png';

var MessageDisplayModal = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(MessageDisplayModal, _React$PureComponent);

  var _super = _createSuper(MessageDisplayModal);

  function MessageDisplayModal() {
    _classCallCheck(this, MessageDisplayModal);

    return _super.apply(this, arguments);
  }

  _createClass(MessageDisplayModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          businessName = _this$props.businessName,
          open = _this$props.open,
          subject = _this$props.subject,
          content = _this$props.content,
          onClose = _this$props.onClose,
          extra = _this$props.extra;
      return /*#__PURE__*/React.createElement(Modal, {
        className: "fm-message-display-modal",
        open: open,
        onClose: onClose,
        dimmer: "inverted"
      }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("div", null, "Message from ", businessName), /*#__PURE__*/React.createElement(Button, {
        onClick: onClose
      }, /*#__PURE__*/React.createElement(Image, {
        src: CloseIconDark,
        fluid: true
      }))), /*#__PURE__*/React.createElement(Modal.Content, {
        scrolling: true
      }, subject && /*#__PURE__*/React.createElement("h4", null, subject), content && /*#__PURE__*/React.createElement(Markdown, null, content), extra));
    }
  }]);

  return MessageDisplayModal;
}(React.PureComponent);

export { MessageDisplayModal as default };
MessageDisplayModal.defaultProps = {
  content: '',
  extra: null
};